import * as Sentry from "@sentry/react";

const SENTRY_ENABLED = import.meta.env.MODE !== "development";

export const initSentry = () => {
    if (!SENTRY_ENABLED) {
        return;
    }
    Sentry.init({
        dsn: "https://527e1f5e9d57cfbfa8a3ee39408657cd@o4506626036924416.ingest.sentry.io/4506831846572032",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            "localhost",
            "wave-content-editor.netlify.app",
            "staging--wave-content-editor.netlify.app",
            "content.voodoo-music.com",
        ],
        // Session Replay
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE,
    });
};

export const setSentryUser = (user: { id: string; email?: string } | null) => {
    if (!SENTRY_ENABLED) {
        return;
    }
    Sentry.setUser(user);
};

export const captureError = (error: any) => {
    if (!SENTRY_ENABLED) {
        return;
    }
    Sentry.captureException(error);
};
